/**
 * Chuẩn hóa lỗi API phát hành/ký HĐ để hiển thị trên UsbTokenErrorModal.
 */

const fieldLabel = (t, fieldKey) => {
  if (!t) return fieldKey;
  const labelKey = `actions.form.${fieldKey}.label`;
  const label = t(labelKey);
  return label && label !== labelKey ? label : fieldKey;
};

/** Chi tiết lỗi từ body API (cùng shape BaseProxy.onSubmitError). */
export const formatApiErrorDetail = (error, t) => {
  if (!error || typeof error !== "object") return null;
  if (error.message && String(error.message).trim()) {
    return String(error.message).trim();
  }
  if (Array.isArray(error.data) && error.data.length) {
    return error.data
      .map(item =>
        typeof item === "string" ? item : JSON.stringify(item)
      )
      .join("\n");
  }
  if (
    error.data &&
    typeof error.data === "object" &&
    !Array.isArray(error.data)
  ) {
    return Object.entries(error.data)
      .map(([key, val]) => {
        const v = Array.isArray(val) ? val[0] : val;
        return `${fieldLabel(t, key)}: ${v}`;
      })
      .join("\n");
  }
  if (error.status_code != null && error.status_code !== "") {
    return t
      ? t("releaseInvoice.modal.responseCode", { code: error.status_code })
      : `Mã phản hồi: ${error.status_code}`;
  }
  return null;
};

const translateApiCode = (apiCode, t) => {
  if (!apiCode || !t) return null;
  const keys = [`releaseInvoice.errors.${apiCode}`, `app.${apiCode}`];
  for (let i = 0; i < keys.length; i += 1) {
    const msg = t(keys[i]);
    if (msg && msg !== keys[i]) return msg;
  }
  return null;
};

/**
 * @param {Object} error - body lỗi từ API
 * @param {string} uiCode - ERROR_CODES (nhóm modal)
 * @param {Function} t - this.$t
 * @returns {{ message_code: string, message: string, detail?: string, api_code?: string }|null}
 */
export const resolveReleaseErrorPayload = (error, uiCode, t) => {
  if (!error || typeof error !== "object") return null;

  const apiCode = error.message_code
    ? String(error.message_code).trim()
    : null;
  const mapped = translateApiCode(apiCode, t);
  const rawDetail = formatApiErrorDetail(error, t);
  const rawMessage =
    error.message && String(error.message).trim()
      ? String(error.message).trim()
      : null;

  let message = mapped;
  let detail = null;

  if (!message) {
    if (rawMessage && rawMessage !== apiCode) {
      message = rawMessage;
    } else if (rawDetail) {
      message = rawDetail;
    }
  } else if (rawDetail && rawDetail !== message) {
    detail = rawDetail;
  } else if (rawMessage && rawMessage !== message && rawMessage !== apiCode) {
    detail = rawMessage;
  }

  if (!message) {
    const fallbackKey = `releaseInvoice.modal.fallback.${uiCode}`;
    const fallback = t(fallbackKey);
    if (fallback && fallback !== fallbackKey) {
      message = fallback;
    }
  }

  if (!message) return null;

  const payload = {
    message_code: uiCode,
    message,
    api_code: apiCode || undefined
  };
  if (detail) payload.detail = detail;
  return payload;
};



// WEBPACK FOOTER //
// ./src/utils/release-invoice-error-display.js